import Overlay from './src/overlay'

export const BOverlay = Overlay
export default BOverlay

export * from './src/overlay'
